import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import '../Styles/Contact.css';
import contact from '../Assets/Images/contact.png'
import { toast } from 'react-hot-toast';

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_nagc6jh', 'template_si7t2x9', form.current, 'tsv1JYCN-Q8C6dayz')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
            e.target.reset();
            toast.success('Message Send');
    };

    return (
        <div className='p-5 lg:py-12'>
            <section id="contact">
                <h1>Contact Us</h1>
                <div class="container">
                    <div class="half-width leftside">
                        <img src={contact} alt="" />
                    </div>
                    <div class="half-width rightside">
                        <h3>Get in touch</h3>
                        <form ref={form} onSubmit={sendEmail}>

                            <div class="contactbox">
                                <input class="contact" type="text" placeholder="Name" name='user_name' required />
                                <input class="contact" type="email" placeholder="Email" name='user_email' required />
                            </div>
                            <div>
                                <input class="contact project" type="text" placeholder="Project" name='subject' required />
                            </div>
                            <div>
                                <textarea class="contact project" name="message" id="" cols="30" rows="10"
                                    placeholder="Message"></textarea>
                            </div>
                            <input class="btn button" type="submit" value="Send Message" />
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;